import DashboardIncidents from './DashboardIncidents';

export default DashboardIncidents;
